"use client"

import ReactDOM from "react-dom"

export function PreloadResources() {
  ReactDOM.preconnect("https://umbraco.euro-drive.co.il", {
    crossOrigin: "anonymous",
  })
  ReactDOM.prefetchDNS("https://www.online.99digital.co.il")
  return null
}
